import { useEffect, Fragment } from 'react';
import { NavLink, Routes, Route, useSearchParams, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import 'normalize.css';
import './App.css';
import logo from './logo.svg';
import { Calc } from './components/Calc';
import Directory from './components/Directory';
import { DirectoryLink } from './components/DirectoryLink';
import Call from './components/Call';

const InvalidRoute = () => (
  <h3>Please scan the QR code again to open the gate.</h3>
);

const MainPage = ({apiUrl}) => {
  const [searchParams] = useSearchParams();
  
  // Check if there's a valid token/ID in the search params
  const hasValidParams = searchParams.toString().length > 5;

  if (!hasValidParams) {
    return <InvalidRoute />;
  }

  return (
    <Fragment>
      <Calc apiUrl={apiUrl}/>
      <DirectoryLink apiUrl={apiUrl}/>
    </Fragment>
  );
};

function App() {
  const url = 'https://gatesentry.herokuapp.com';
  // const url = 'https://gatesentry-dev.herokuapp.com';
  const location = useLocation();

  useEffect(() => {
    // Set 5 minute timer if deciding to call/calling
    if (location.pathname === '/call') {
      const timer = setTimeout(() => {
        window.location = '/';
      }, 600000);
      return () => clearTimeout(timer);
    }
    if (location.pathname === '/directory') {
      // Allow 5 minutes in the directory?
      const timer = setTimeout(() => {
        window.location = '/';
      }, 600000);
      return () => clearTimeout(timer);
    }
    if (location.pathname === '/') {
      // Allow 2 minutes in keypad?
      const timer = setTimeout(() => {
        console.log('Redirecting to main page due to inactivity. base page');
        window.location = '/';
      }, 120000);
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  return (
    <MainWrapper className="App">
      <header>
        <img id="logo" alt="Gate Sentry Visitor Management" src={logo} />
      </header>
      <Routes>
        <Route path="/" element={<MainPage apiUrl={url}/>} />
        <Route path="/directory" element={<Directory apiUrl={url}/>} />
        <Route path="/call" element={<Call apiUrl={url} />} />
        <Route path="*" element={<InvalidRoute />} />
      </Routes>
      <footer id="footer">
        <NavLink id="gatelink" to={"https://gatesentry.com/"}>GATESENTRY.COM</NavLink>
      </footer>
    </MainWrapper>
  );
}

const MainWrapper = styled.main`
  h3 {
    margin-top: 5rem;
    text-align: center;
    color: white;
  }

  box-sizing: border-box;
  grid-area: main;
  background: #000;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 28rem;
  align-items: center;

  header {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 20vh;
    max-height: 30rem;
    h3 {
      margin-top: 0.3rem;
    }
  }

  #logo {
    margin-top: 1vh;
    width: auto;
    height: 18vh;
    max-height: 16rem;
    min-height: 7rem;
  }

  #footer {
    margin-top: auto;
    padding-bottom: 0.2rem;
  }

  #gatelink {
    color: #b70100;
    font-size: 1.2em;
    text-decoration: none;
    cursor: pointer;
  }

  #directorylink {
    color: #b70100;
    font-size: 1.4em;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
  }
`;

export default App;